/* @flow */

import * as React from 'react';

import { PictoArrowDown } from '../../pictos/Element';
import './PlaceholderVodEpisode.css';

type PlaceholderVodEpisodePropType = {
  +index: number,
};

const PlaceholderVodEpisode = ({ index }: PlaceholderVodEpisodePropType): React.Node => (
  <div className='episode vod'>
    <div className='header'>
      <div className='title'>
        {index + 1} - <div className='empty' />
      </div>
      <div className='actions'>
        <div className='pricingLink' />
        <div className='pricingLink' />
        <PictoArrowDown className='arrow' />
      </div>
    </div>
  </div>
);

export default PlaceholderVodEpisode;
